<template>
  <section class="section -center">
    <h2 class="section__title" v-reveal>{{ content.title }}</h2>
    <p class="section__text" v-reveal>{{ content.subtitle }}</p>

    <div class="news" v-reveal>
      <div class="card-news" v-for="(card, key) in content.posts" :key="key">
        <div
          class="card-news__image"
          :style="{ backgroundImage: `url(${card.image.md || card.image.original})` }"
        ></div>

        <div class="card-news__content">
          <h3 class="card-news__title">{{ card.title }}</h3>
          <p class="card-news__text">{{ parseText(card.content) }}</p>
          <a class="card-news__link" v-if="card.link" :href="card.link" target="_blank">
            Lire la suite
            <Icon id="arrow" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionNews',
  props: {
    content: {
      type: Object,
      default: () => {
        return {
          title: 'AUX DERNIÈRES NOUVELLES',
          subtitle:
            'Explorez ce qui se passe dans le monde de Les Filles et les Sciences dernièrement!',
          cards: [
            {
              title: 'SOIRÉE DE FINANCEMENT ET RENCONTRE DES PARTENAIRES',
              text: 'Mardi le 12 avril 2023 avait lieu la grande soirée de financement annuelle pour l’événement Les Filles et les Sciences. Étaient regroupés tous nos partenaires et plusieurs professeurs des écoles secondaires concernées…',
              url: '#',
              image: 'https://placehold.co/200x300',
            },
            {
              title: 'ACTIVITÉ DE DISCUSSION ENTRE ÉTUDIANTES',
              text: 'Il est important pour nous d’encourager les rencontres entre les étudiantes afin qu’elles puissent poser leurs questions et parler de leur parcours dans un environnement accueillant et amical. Notre partenaire a donc organisé une…',
              url: '#',
              image: 'https://placehold.co/200x300',
            },
            {
              title: 'LOREM IPSUM DOLAR SIT AMET',
              text: 'Pellentesque luctus pulvinar mauris sit amet consequat. In dolor ipsum, interdum a egestas quis, semper eget leo.',
              url: null,
              image: 'https://placehold.co/200x300',
            },
          ],
        }
      },
    },
  },
  methods: {
    parseText(text) {
      if (text.length < 300) return text
      else {
        let newText = text.slice(0, 300)
        newText = text.slice(0, newText.lastIndexOf(' '))
        return `${newText}...`
      }
    },
  },
}
</script>
